import { useMutation, useQuery } from '@tanstack/react-query';
import { getLocale, GetLocaleParams } from '../services/localeService';

export function useLocale(params: GetLocaleParams | null) {
  const hasParams = params != null && ((params.lat != null && params.lon != null) || !!params.postalCode);

  return useQuery({
    queryKey: ['locale', params],
    queryFn: () => getLocale(params!),
    enabled: hasParams,
    staleTime: 1000 * 60 * 30, // locale rarely changes, cache 30 min
  });
}

/**
 * Imperative locale lookup for one-off resolutions during a user action — e.g.
 * resolving a ZIP the user typed in the order gate so we can compare it against
 * the dish's locale before committing the location. Use `useLocale` for
 * declarative/cached reads.
 */
export function useResolveLocale() {
  return useMutation({
    mutationFn: (params: GetLocaleParams) => getLocale(params),
  });
}
